import React, { FC } from "react";
import st from './PeriodSwitcher.module.scss';
import { useTypedSelector } from "../../../../../../../hooks/useTypedSelector";
import { EfficiencySliceState } from "../../../../../../../store/reducers/dashboard/works/efficiency";
import { IdlesSliceState } from "../../../../../../../store/reducers/dashboard/works/idles";
import { TabButton } from "@infobis/ui-styles-utils";
import { Type as T } from "@infobis/ui-styles-utils";
import { WorkDisplayPeriod } from "../../../../../../../types/service/dashboard/IWorksDashboardService";

type PeriodSwitcherProps = {
    period: WorkDisplayPeriod
    setPeriod: (period: WorkDisplayPeriod) => void
}

const PeriodSwitcher: FC<PeriodSwitcherProps> = (props) => {
    const {
        period,
        setPeriod
    } = props;

    const { isApiLoading: isEfficiencyLoading } = useTypedSelector<EfficiencySliceState>(state => state.efficiencyDetalization)
    const { isApiLoading: isIdlesLoading } = useTypedSelector<IdlesSliceState>(state => state.idlesDetalization)

    if (isEfficiencyLoading || isIdlesLoading) return <></>

    return (
        <div className={st['switcher']}>
            <TabButton
                size={T.Size.SMALL}
                selected={period}
                values={[{id: 'today', label: 'Сегодня'}, {id: 'full', label: 'За весь период'}]}
                clickHandler={(id) => setPeriod(id as WorkDisplayPeriod)}
            />
        </div>
    )
}

export default PeriodSwitcher;